<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <div class="row">
        <div class="col">
          <div class="p-3">
            <h2 class="main-title text-center">Dividend Updates</h2>
            <p class="text-muted text-right">As of {{ FormatDate(upcomingDividends.dateUpdated) }}</p>  
            <div class="table-responsive mt-3">
            <table class="table secondary-table table-bordered text-nowrap">
                <thead>
                  <tr>
                    <th class="text-center">Symbol</th>
                    <th class="text-center">Company</th>
                    <th class="text-center">Type of Security</th>
                    <th class="text-center">Type of Dividend</th>
                    <th class="text-center">Dividend Payment</th>
                    <th class="text-center">Ex-Date</th>
                    <th class="text-center">Record Date</th>
                    <th class="text-center">Payment Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in generateList(sortedList)[currentPage -1]" :key="index">
                    <td class="text-left">
                      <b>{{ item.symbol }}</b>
                    </td>
                    <td class="text-left">{{ item.company }}</td>
                    <td class="text-left">{{ item.typeOfSecurity }}</td>
                    <td class="text-left">{{ item.typeOfDividend}}</td>
                    <td class="text-right">{{ item.dividendPayment }} </td>
                    <td class="text-right">{{ FormatData(item.exDate) }} </td>
                    <td class="text-right">{{ FormatData(item.recordDate) }} </td>
                     <td class="text-right">{{ FormatData(item.paymentDate)}} </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr  style="background-color:#ffffff;">
                    <td colspan="100%">
                  <div   v-if="sortedList.length == 0" class="d-flex justify-content-center align-items-center">
                   <Noresult />
                   </div>
            
                    </td>
                  </tr>
                </tbody>
              </table>
              <br>
         <p class="text-muted" >Source: PSE Edge</p>
            </div>
            <div class="d-flex justify-content-center mt-5" v-if="sortedList.length != 0">
              <b-pagination
                size="lg"
                v-model="currentPage"
                :total-rows="upcomingDividends.dividendsList.length"
                 :per-page="perPage"
             
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navHeader from "../../ResearchPages/NavHeader";
import Noresult from "../NoResult.vue";

import { mapState } from "vuex";
import moment from "moment";
export default {
  components: {
    navHeader,
    Noresult,
  },

  data() {
    return {
      perPage: 30,
      currentPage: 1,
    };
  },

  computed: {
    ...mapState({
      upcomingDividends: (state) =>
        state.philstocksResearch.upcomingDividends,
    }),
    sortedList(){
      return this.$store.state.philstocksResearch.sortedList;
    }
  },
  methods: {
      GoogleAnalytics() {
      this.$gtag.event("DividendsUpdate", { method: "Google" });
    },

        generateList(data) {
      var result = [];
      var list = 30;
      if (data == undefined) {
        result = [];
      } else {
        result = data.reduce((resultArray, item, index) => {
          const listIndex = Math.floor(index / list);

          if (!resultArray[listIndex]) {
            resultArray[listIndex] = []; 
          }

          resultArray[listIndex].push(item);

          return resultArray;
        }, []);
      }
      return result;
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment.utc(date).format('LL');

        
      }
      return result;
    },

    FormatData(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment(date).format("MM/DD/YYYY");
      }
      return result;
    },
  },

  async mounted() {
    this.$store.dispatch("philstocksResearch/GetUpcomingDividendstContent");
  },
};
</script>

<style></style>
